// extracted by mini-css-extract-plugin
export default {"container":"ColorPicker_container__ClXJW","wrapper":"ColorPicker_wrapper__H8SAL","bottom":"ColorPicker_bottom__cta57"};